module.exports = __webpack_public_path__ + "img/16.dffb7a0e.png";